module.exports = __webpack_public_path__ + "media/images/lb/600-90d644a26f42be27b9bdded335f543d9.svg";